import React from 'react'
import { useIntl } from 'react-intl';
import moment from 'moment';
import { connect, useSelector } from 'react-redux';
import ViewTableInformation from '../../../Common/TableRecords/ViewTableInformation';
import ViewTableBodyInformation from '../../../Common/TableRecords/ViewTableBodyInformation';
import { BookingDetailsIcons } from '../../../../components/Common/Assets/SvgIconComponent/SideMenuIcons';
import formatReservationState from '../../../../helpers/formatReservationState';
import { formatTime } from '../../../../helpers/formatting';
import { getDynamicTitle } from '../../../../helpers/GetDynamicItemName/getDynamicName';
import messages from '../../../../locale/jsonMessages';
import { dateFormat } from '../../../../config';
import { formatLocalizedDate } from '../../../../helpers/formatLocateDate';

const ReservationDetails = ({ data, locale }) => {
    const { formatMessage } = useIntl();
    let bookingType, formattedStartTime, formattedEndTime;
    if (data?.bookingType) bookingType = data?.bookingType?.charAt(0).toUpperCase() + data?.bookingType?.slice(1);
    formattedStartTime = formatTime(data?.startTime);
    formattedEndTime = formatTime(data?.endTime);
    let dynamicTitleContent, dynamicTitle;
    const dynamicListTitle = useSelector(state => state?.dynamicListTitles?.data?.dynamicListTitle)

    dynamicTitle = getDynamicTitle({ data: dynamicListTitle, locale, id: data?.listData?.id });

    return (
        <div>
            <ViewTableInformation title={formatMessage(messages.bookingDetails)} icon={<BookingDetailsIcons />}>
                {data?.id && <ViewTableBodyInformation
                    title={formatMessage(messages.reservationId)}
                    value={data?.id}
                />}
                {data?.confirmationCode && <ViewTableBodyInformation
                    title={formatMessage(messages.confirmationCode)}
                    value={data?.confirmationCode}
                />}
                {data?.reservationState && <ViewTableBodyInformation
                    title={formatMessage(messages.reservationStatus)}
                    value={formatReservationState(data?.reservationState, { formatMessage })}
                />}
                {data?.listData?.id && <ViewTableBodyInformation
                    title={formatMessage(messages.carNameLabel)}
                    linkText={(dynamicTitle ? dynamicTitle : (data?.listTitle ? data?.listTitle : data?.listData?.title))}
                    linkData={"/cars/" + data?.listData?.id}
                />}
                {data?.checkIn && <ViewTableBodyInformation
                    title={formatMessage(messages.tripStartDate)}
                    value={`${formatLocalizedDate(data?.checkIn, locale, dateFormat?.dayFullMonthFormat)}, ${formattedStartTime}`}
                />}
                {data?.checkOut && <ViewTableBodyInformation
                    title={formatMessage(messages.tripEndDate)}
                    value={`${formatLocalizedDate(data?.checkOut, locale, dateFormat?.dayFullMonthFormat)}, ${formattedEndTime}`}
                />}
                <ViewTableBodyInformation
                    title={formatMessage(messages.tripLength)}
                    value={`${data?.dayDifference} ${formatMessage({ id: data?.dayDifference > 1 ? 'nights' : 'night' })}`}
                />
                {bookingType && <ViewTableBodyInformation
                    title={formatMessage(messages.bookingMethod)}
                    value={bookingType}
                />}
                {data?.paymentMethodId && <ViewTableBodyInformation
                    title={formatMessage(messages.paymentMethod)}
                    value={formatMessage({ id: data?.paymentMethodId == 1 ? 'paypal' : 'stripe' })}
                />}
            </ViewTableInformation>
        </div>
    )
}

const mapState = (state) => ({
    locale: state?.intl?.locale
});

const mapDispatch = {};

export default connect(mapState, mapDispatch)(ReservationDetails);
